const LIGHT = '#E7E7E7';
const DARK = '#2C2C2C';
const PRIMARY = '#4A9FEA';
const SECONDARY = '#186CB7';
const FONT_FAMILY = 'RobotoSlab';

export const lightTheme = {
  color: {
    primary: PRIMARY,
    secondary: SECONDARY,
  },
  // Background colors
  background: {
    primary: LIGHT,
    secondary: '#f5f5f5',
    tertiary: '#ffffff',
    homeSection: '#E3F2FD',
    negative: DARK,
  },
  // Text colors
  text: {
    primary: DARK,
    secondary: '#424242',
    tertiary: '#666666',
    negative: LIGHT,
  },
  // Button colors
  button: {
    color: LIGHT,
    background: PRIMARY
  },
  // Brand/Accent colors
  accent: {
    secondary: '#3B6FB3',  // blue
    error: '#B33B3B',      // red
    warning: '#ff9800',    // orange
    success: '#769358',    // green
    marter: 'rgba(255, 205, 25, 0.5)',
    disabled: "rgba(0, 0, 0, 0.38)",
  },
  // Border colors
  border: {
    light: '#FCF8F3',
    medium: '#bdbdbd',
    dark: '#9e9e9e',
  },
  // Navbar colors
  navbar: {
    text: LIGHT,
  },
  scrollbar: PRIMARY,
  scrollbarHover: SECONDARY,
  fontFamily: FONT_FAMILY,
};

export const darkTheme = {
  color: {
    primary: SECONDARY,
    secondary: PRIMARY,
  },
  // Background colors
  background: {
    primary: DARK,
    secondary: '#121212',
    tertiary: '#1E1E1E',
    homeSection: '#0A1929',
    negative: LIGHT,
  },
  // Text colors
  text: {
    primary: LIGHT,
    secondary: '#e0e0e0',
    tertiary: '#bdbdbd',
    negative: DARK,
  },
  // Button colors
  button: {
    color: DARK,
    background: SECONDARY
  },
  // Brand/Accent colors
  accent: {
    secondary: '#3B6FB3',  // blue
    error: '#B33B3B',      // red
    warning: '#ff9800',    // orange
    success: '#769358',    // green
    marter: 'rgba(255, 205, 25, 0.5)',
    disabled: "rgba(255, 255, 255, 0.5)",
  },
  // Border colors
  border: {
    light: '#424242',
    medium: '#616161',
    dark: '#757575',
  },
  // Navbar colors
  navbar: {
    text: DARK,
  },
  scrollbar: SECONDARY,
  scrollbarHover: PRIMARY,
  fontFamily: FONT_FAMILY,
};